
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IAppForm } from './IAppForm'
import { ApplicationModule } from '@/store'
import CFInput from '../inputs/CFInput'

	@Component({
	  name: 'DateOfBirth'
	})
export default class DateOfBirth extends Vue implements IAppForm {
  // #region  Props

		@Prop() wizardIndex!: number;

		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit', this.wizardIndex)
		}

		validate () {
		  return (this.$refs.dobInput as unknown as CFInput).validate()
		}

		previous () {
		  this.$emit('previous')
		  ApplicationModule.updateForm(ApplicationModule.formCopy)
		}

  // #endregion
}
